<template>
    <div class="d-flex align-center text-capitalize">
        <v-icon class="text-info" start size="small">mdi-silverware-fork-knife</v-icon>
        <span class="text-caption">{{ label }}</span>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class CruiseMealTypeLabel extends Vue {
        @Prop({required: true}) offer

        get label() {
            return this.offer.mealType.name?.toLowerCase()
        }
    }

    export default CruiseMealTypeLabel
</script>
